const countIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.732558 1.2962C1.13714 1.2962 1.46512 1.63829 1.46512 2.06028V6.6067H5.82399C6.22857 6.6067 6.55655 6.94879 6.55655 7.37078C6.55655 7.79277 6.22857 8.13486 5.82399 8.13486H0.732558C0.327977 8.13486 0 7.79277 0 7.37078V2.06028C0 1.63829 0.327977 1.2962 0.732558 1.2962Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.96926 0.201759C10.922 -0.203385 12.9461 0.0045494 14.7856 0.799269C16.6251 1.59399 18.1973 2.9398 19.3035 4.66651C20.4097 6.39323 21.0001 8.4233 21.0001 10.5C21.0001 12.5767 20.4097 14.6068 19.3035 16.3335C18.1973 18.0602 16.6251 19.406 14.7856 20.2007C12.9461 20.9954 10.922 21.2034 8.96926 20.7982C7.01649 20.3931 5.22274 19.3931 3.81487 17.9246C3.52879 17.6262 3.52879 17.1424 3.81487 16.844C4.10095 16.5457 4.56478 16.5457 4.85086 16.844C6.05384 18.0988 7.58652 18.9533 9.25509 19.2994C10.9237 19.6456 12.6532 19.468 14.2249 18.7889C15.7967 18.1098 17.1401 16.9599 18.0853 15.4845C19.0305 14.0091 19.5349 12.2745 19.5349 10.5C19.5349 8.72554 19.0305 6.99092 18.0853 5.51551C17.1401 4.0401 15.7967 2.89016 14.2249 2.2111C12.6532 1.53204 10.9237 1.35437 9.25509 1.70055C7.58652 2.04673 6.05384 2.90122 4.85086 4.15595L1.25068 7.91104C0.964595 8.20943 0.500765 8.20943 0.214683 7.91104C-0.0713983 7.61265 -0.0713984 7.12886 0.214683 6.83047L3.81487 3.07538C5.22274 1.60693 7.01649 0.606904 8.96926 0.201759Z"
      fill="#6B00DF"
    />
    <path
      d="M10.039 13.2761H12.9483V14.3415H8.19512V13.4912L10.6332 11.0327C11.1658 10.5 11.5449 10.0083 11.5449 9.37317C11.5449 8.6561 11.1351 8.3283 10.5102 8.3283C9.83414 8.3283 9.35268 8.75854 9.35268 9.5883L8.10292 9.59854C8.09268 8.10293 9.11707 7.22195 10.5 7.22195C11.8829 7.22195 12.8151 8.03122 12.8151 9.37317C12.8151 10.2541 12.3746 10.9507 11.5756 11.7395L10.039 13.2761Z"
      fill="#6B00DF"
    />
  </svg>
);

const startValueIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.10623 7.06831C1.35599 8.90336 1.22778 10.9338 1.74123 12.8486C2.25469 14.7634 3.38154 16.4573 4.94922 17.6708C6.51691 18.8843 8.43915 19.5507 10.4216 19.5678C12.404 19.585 14.3374 18.952 15.9259 17.7658C17.5143 16.5796 18.6703 14.9055 19.2168 12.9998C19.7633 11.0941 19.6703 9.06179 18.9519 7.21404C18.2335 5.36629 16.9294 3.80481 15.2391 2.76874C13.5489 1.73267 11.5657 1.27903 9.59315 1.47729C9.19975 1.51683 8.84878 1.22996 8.80924 0.836561C8.7697 0.443158 9.05656 0.092187 9.44996 0.052647C11.734 -0.176913 14.0303 0.348356 15.9874 1.54802C17.9445 2.74768 19.4546 4.5557 20.2864 6.6952C21.1182 8.8347 21.226 11.1879 20.5932 13.3945C19.9604 15.6011 18.6219 17.5395 16.7826 18.913C14.9434 20.2865 12.7046 21.0195 10.4092 20.9996C8.11374 20.9798 5.88801 20.2082 4.07279 18.8031C2.25756 17.3979 0.952794 15.4366 0.35827 13.2194C-0.236255 11.0023 -0.0878019 8.65126 0.780897 6.52646C0.930523 6.16048 1.34851 5.9851 1.71449 6.13472C2.08047 6.28435 2.25586 6.70233 2.10623 7.06831Z"
      fill="#6B00DF"
    />
    <path
      d="M6.41166 12.2476H8.87327V13.3171H4.54932V12.4689L6.74357 10.2654C7.16766 9.84132 7.48113 9.41722 7.48113 8.88249C7.48113 8.30166 7.15844 8.02507 6.66059 8.02507C6.11664 8.02507 5.72942 8.38463 5.72942 9.08532L4.44791 9.09454C4.44791 7.70239 5.36986 6.90951 6.65137 6.90951C7.9421 6.90951 8.77186 7.66551 8.77186 8.88249C8.77186 9.71224 8.39386 10.3023 7.62864 11.0491L6.41166 12.2476Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5172 6.62214L17.7768 9.88173C17.9768 10.0818 17.9768 10.4061 17.7768 10.6061L14.5172 13.8657C14.3172 14.0657 13.9929 14.0657 13.7929 13.8657C13.5929 13.6656 13.5929 13.3413 13.7929 13.1413L16.1781 10.7561L10.2439 10.7561C9.96103 10.7561 9.73171 10.5268 9.73171 10.2439C9.73171 9.96102 9.96103 9.73171 10.2439 9.73171L16.1781 9.73171L13.7929 7.34649C13.5929 7.14647 13.5929 6.82216 13.7929 6.62214C13.9929 6.42211 14.3172 6.42211 14.5172 6.62214Z"
      fill="#6B00DF"
    />
  </svg>
);

export { countIcon, startValueIcon };
